import {FoodOrderingState, GlobalState} from '@/types/state'
import * as actionTypes from '@/store/action-types'
import * as mutationTypes from '@/store/mutation-types'
import MenuOffer from '@/model/MenuOffer'
import MenuReservation from '@/model/MenuReservation'
import * as getterTypes from '@/store/getter-types'
import DailyMenuOffer from '@/model/DailyMenuOffer'
import {DailyMenuChangeSet} from '@/types'
import {createInitialDailyMenuTopGroupChangeSetUpdate, updateSelectedItemByOfferId} from '@/services/food-ordering'
import moment from 'moment'
import axios from '@/plugins/axios'
import MenuGroupItem from '@/model/MenuGroupItem'
import { USER_DAILY_MENU, USER_SETTINGS_4_ORDERING} from '@/store/action-types'
import Moment from 'moment'
import store from '@/store'
import {USER_LOGGED_IN} from '@/store/getter-types'
import {
  ChangeExistingReservationWithIdPayload, CreateNewReservationPayload,
  FetchOfferReservationPayload,
  FetchStructuredMenuOfferPayload,
} from '@/types/payload'
import {
  OfferReservationResponse,
  StructuredMenuOfferResponse
} from '@/types/service-response'
import {AxiosResponse} from 'axios'
import MenuReservationItem from '@/model/MenuReservationItem'
import {Invoice} from "@/model/Invoice";
import BusinessTimeBlockCollection from "@/model/TimeBlockCollection";
import DailyMenuOption from "@/model/DailyMenuOption";

const state: FoodOrderingState = {
  userDailyMenu: MenuOffer.createEmpty(),
  loadingData: false,
  currentDailyMenuOffer: undefined,
  currentDailyMenuTopGroupOffer: undefined,
  dailyMenuTopGroupChangeSet: undefined,
  dailyMenuChangeSet: undefined,
  currentUserReservationRangeData: undefined,
  reservationDataSaved: undefined,
  selectedView: 'MASTER',
  userSettings4Ordering: undefined,
  selectedMenuItem: undefined
}

const getters = {

  [getterTypes.GET_SELECTED_MENU_ITEM](state: FoodOrderingState): string | undefined {
    return state.selectedMenuItem
  },

  [getterTypes.MENU_OFFER](state: FoodOrderingState): MenuOffer {
    return state.userDailyMenu
  },

  [getterTypes.DAILY_MENU_OFFER](state: FoodOrderingState): DailyMenuOffer | undefined {
    return state.currentDailyMenuOffer
  },

  [getterTypes.DAILY_MENU_TOP_GROUP_OFFER](state: FoodOrderingState): MenuGroupItem | undefined {
    return state.currentDailyMenuTopGroupOffer
  },

  [getterTypes.DAILY_MENU_CHANGE_SET](state: FoodOrderingState): DailyMenuChangeSet | undefined {
    return state.dailyMenuChangeSet
  },

  [getterTypes.DAILY_MENU_TOP_GROUP_CHANGE_SET](state: FoodOrderingState): any | undefined {
    return state.dailyMenuTopGroupChangeSet
  },

  [getterTypes.LOADING_DAILYMENU](state: FoodOrderingState): boolean {
    return state.loadingData
  },

  [getterTypes.SELECTED_VIEW](state: FoodOrderingState): string | undefined {
    return state.selectedView
  },

  [getterTypes.CURRENT_USER_RESERVATION_RANGE_DATA](state: FoodOrderingState): MenuReservation | undefined {
    return state.currentUserReservationRangeData
  },

  [getterTypes.DAILY_MENU_TOP_GROUP_SAVED](state: FoodOrderingState): MenuReservation | undefined {
    return state.reservationDataSaved
  },

  [getterTypes.USER_SETTINGS_4_ORDERING](state: FoodOrderingState): MenuReservation | undefined {
    return state.userSettings4Ordering
  },
}

const mutations = {

  [mutationTypes.SET_CURRENT_USER_DAILYMENU](state: FoodOrderingState, payload: MenuOffer): void {
    state.userDailyMenu = payload
  },

  [mutationTypes.SET_CURRENT_DAILYMENU_OFFER](state: FoodOrderingState, payload: DailyMenuOffer): void {
    state.currentDailyMenuOffer = payload
  },

  [mutationTypes.SET_CURRENT_DAILYMENU_TOP_GROUP_OFFER](state: FoodOrderingState, payload: MenuGroupItem): void {
    state.currentDailyMenuTopGroupOffer = payload
  },

  [mutationTypes.SET_DAILYMENU_TOP_GROUP_OFFER_CHANGE_SET](state: FoodOrderingState, payload: any): void {
    state.dailyMenuTopGroupChangeSet = payload
  },

  [mutationTypes.SET_DAILYMENU_OFFER_CHANGE_SET](state: FoodOrderingState, payload: DailyMenuChangeSet | undefined): void {
    state.dailyMenuChangeSet = payload
  },
  [mutationTypes.SET_LOADING_DAILYMENU](state: FoodOrderingState, payload: boolean): void {
    state.loadingData = payload
  },
  [mutationTypes.SET_SELECTED_VIEW](state: FoodOrderingState, payload: string): void {
    state.selectedView = payload
  },

  [mutationTypes.SET_CURRENT_USER_RESERVATION_RANGE_DATA](state: FoodOrderingState, payload: any): void {
    state.currentUserReservationRangeData = payload
  },

  [mutationTypes.SET_DAILY_MENU_TOP_GROUP_SAVED](state: FoodOrderingState, payload: any): void {
    state.reservationDataSaved = payload
  },

  [mutationTypes.SET_USER_SETTINGS_4_ORDERING](state: FoodOrderingState, payload: any): void {
    state.userSettings4Ordering = payload
  },

  [mutationTypes.SET_SELECTED_MENU_ITEM_MUTATION](state: FoodOrderingState, payload: string | undefined): void {
    state.selectedMenuItem = payload
  },

}

const actions = {
  [actionTypes.SET_SELECTED_MENU_ITEM] ({ commit }: { commit: Function }, payload: string | undefined): void {
    commit(mutationTypes.SET_SELECTED_MENU_ITEM_MUTATION, payload)
  },

  async [actionTypes.USER_SETTINGS_4_ORDERING]({commit}: { commit: Function }, payload: any): Promise<void> {

    if (payload) {
      const settingsData = {
        last_ordering: {
          hour: '18:00',
          days_before: '1'
        }
      }

      commit(mutationTypes.SET_USER_SETTINGS_4_ORDERING, settingsData)

    }

  },

  async [actionTypes.USER_DAILY_MENU]({commit, dispatch}: { commit: Function, dispatch: Function }, payload: any): Promise<void> {

    const user = store.getters[USER_LOGGED_IN]

    if (payload) {
      let headers = {
        'Authorization': 'Bearer ' + localStorage.getItem('token')
      }

      dispatch(USER_SETTINGS_4_ORDERING, {})

      commit(mutationTypes.SET_LOADING_DAILYMENU, true)
      let menuOfferDataResponse = await axios.get('/api/food-ordering/' + user.tenant.code + '/menu-offer', {
        params: {
          's': payload.from,
          'e': payload.to,
          'bid': payload.bid,
        },
        headers: headers
      })

      let reservationDataResponse = await axios.get('/api/food-ordering/offer-reservation?date[before]=' + payload.to + '&date[after]=' + payload.from + '&boarder.id=' + payload.user_id, {headers: headers})

      const offerData = MenuOffer.createFromResponse(menuOfferDataResponse.data)
      commit(mutationTypes.SET_CURRENT_USER_DAILYMENU, offerData)

      const reservationData = MenuReservation.createFromResponse(reservationDataResponse.data)
      commit(mutationTypes.SET_CURRENT_USER_RESERVATION_RANGE_DATA, reservationData)

      commit(mutationTypes.SET_LOADING_DAILYMENU, false)
    }

  },

  async [actionTypes.SWITCH_DAILYMENU]({commit}: { commit: Function }, payload: any): Promise<void> {

    if (payload.day == undefined) {
      return
    }

    commit(mutationTypes.SET_LOADING_DAILYMENU, true)

    commit(mutationTypes.SET_CURRENT_DAILYMENU_TOP_GROUP_OFFER, payload.topGroup)

    let headers = {
      'Authorization': 'Bearer ' + localStorage.getItem('token')
    }

    let res = await axios.get('/api/food-ordering/offer-reservation?date[before]=' + payload.day + '&date[after]=' + payload.day + '&boarder.id=' + payload.user_id, {headers: headers})

    const changeSet = createInitialDailyMenuTopGroupChangeSetUpdate(payload, res.data)
    commit(mutationTypes.SET_DAILYMENU_TOP_GROUP_OFFER_CHANGE_SET, changeSet)

    updateSelectedItemByOfferId(res.data)

    commit(mutationTypes.SET_LOADING_DAILYMENU, false)

  },

  async [actionTypes.STORNO_DAILYMENU]({commit, state, dispatch}: { commit: Function, state: FoodOrderingState, dispatch: Function }, payload: any): Promise<void> {


    var order: any | undefined = state.dailyMenuTopGroupChangeSet
    var date = order.date
    var list = order.selectedItemList
    let offer_ids: number[] = []
    let topgroupId = order.topGroupId
    let reservationId = order.reservationId

    list.forEach((item: any) => {
      offer_ids.push(item.selectedItem.offer.id)
    })

    let headers = {
      'Authorization': 'Bearer ' + localStorage.getItem('token')
    }

    var data = {
      'status': 'canceled',
      'reservedOfferCollection': offer_ids
    }

    let res = await axios.put('/api/food-ordering/offer-reservation/' + reservationId, data, {headers: headers})

    const changeSet = {reservationId: reservationId, status: data.status}
    commit(mutationTypes.SET_DAILY_MENU_TOP_GROUP_SAVED, changeSet)

    if (state.userDailyMenu && state.userDailyMenu.menuList.length > 0) {
      const start_date = Moment(state.userDailyMenu.menuList[0].date).format('Y-MM-DD')
      const end_date = Moment(state.userDailyMenu.menuList[state.userDailyMenu.menuList.length - 1].date).format('Y-MM-DD')

      dispatch(USER_DAILY_MENU, {from: start_date, to: end_date, user_id: order.user_id})

    }
  },

  async [actionTypes.SAVE_DAILYMENU]({commit, state, dispatch}: { commit: Function, state: FoodOrderingState, dispatch: Function }, payload: any): Promise<void> {

    var order: any | undefined = state.dailyMenuTopGroupChangeSet
    var date = order.date
    var list = order.selectedItemList
    let offer_ids: number[] = []
    let topgroupId = order.topGroupId
    let reservationId = order.reservationId

    list.forEach((item: any) => {
      offer_ids.push(item.selectedItem.offer.id)
    })

    let headers = {
      'Authorization': 'Bearer ' + localStorage.getItem('token')
    }
    //
    var data = {
      'status': 'active',
      'reservedOfferCollection': offer_ids
    }

    let res = await axios.put('/api/food-ordering/offer-reservation/' + reservationId, data, {headers: headers})

    const changeSet = {reservationId: reservationId, status: data.status}
    commit(mutationTypes.SET_DAILY_MENU_TOP_GROUP_SAVED, changeSet)

    if (state.userDailyMenu && state.userDailyMenu.menuList.length > 0) {
      const start_date = Moment(state.userDailyMenu.menuList[0].date).format('Y-MM-DD')
      const end_date = Moment(state.userDailyMenu.menuList[state.userDailyMenu.menuList.length - 1].date).format('Y-MM-DD')

      dispatch(USER_DAILY_MENU, {from: start_date, to: end_date, user_id: order.user_id})

    }

  },

  async [actionTypes.SAVE_RESTORE_DAILYMENU]({commit, state, dispatch}: { commit: Function, state: FoodOrderingState, dispatch: Function }, payload: any): Promise<void> {

    var order: any | undefined = state.dailyMenuTopGroupChangeSet
    let reservationId = order.reservationId

    let headers = {
      'Authorization': 'Bearer ' + localStorage.getItem('token')
    }
    //
    var data = {
      'status': 'active'
    }

    let res = await axios.put('/api/food-ordering/offer-reservation/' + reservationId, data, {headers: headers})

    const changeSet = {reservationId: reservationId, status: data.status}
    commit(mutationTypes.SET_DAILY_MENU_TOP_GROUP_SAVED, changeSet)

    if (state.userDailyMenu && state.userDailyMenu.menuList.length > 0) {
      const start_date = Moment(state.userDailyMenu.menuList[0].date).format('Y-MM-DD')
      const end_date = Moment(state.userDailyMenu.menuList[state.userDailyMenu.menuList.length - 1].date).format('Y-MM-DD')

      dispatch(USER_DAILY_MENU, {from: start_date, to: end_date, user_id: order.user_id})

    }

  },

  [actionTypes.SET_SELECTED_VIEW]({commit, state}: { commit: Function, state: FoodOrderingState }, payload: string): void {
    commit(mutationTypes.SET_SELECTED_VIEW, payload)
  },

  /**
   * Načítanie ponuky stravy pre dátumový rozsah
   *
   * Ponuka obsahuje štruktúrované dáta na jednotlivé dni. Skupiny, podskupiny, sloty, ponuky v slotoch a referenčné
   * jedlá.
   *
   * @param payload FetchStructuredMenuOfferPayload
   */
  async [actionTypes.FETCH_STRUCTURED_MENU_OFFER]({}, payload: FetchStructuredMenuOfferPayload): Promise<StructuredMenuOfferResponse> {
    const response: AxiosResponse = await axios.get(`/api/food-ordering/${payload.tenantCode}/menu-offer`, {
      params: {
        's': moment(payload.dateFrom).format('YYYY-MM-DD'),
        'e': moment(payload.dateTo).format('YYYY-MM-DD'),
        'bid': payload.businessId
      },

      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem('token')
      }
    })

    return response.data as StructuredMenuOfferResponse
  },

  /**
   * Načítanie rezervácií používateľa pre dátumový rozsah
   *
   * Dáta obsahujú informácie o stave objednávky na daný deň a položky ktoré sú v objednávke.
   *
   * @param payload FetchStructuredMenuOfferPayload
   */
  async [actionTypes.FETCH_OFFER_RESERVATION]({}, payload: FetchOfferReservationPayload): Promise<OfferReservationResponse> {
    const response: AxiosResponse = await axios.get('/api/food-ordering/offer-reservation', {
      params: {
        'date[before]': moment(payload.dateTo).format('YYYY-MM-DD'),
        'date[after]': moment(payload.dateFrom).format('YYYY-MM-DD'),
        'boarder.id': payload.boarderId
      },

      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem('token')
      }
    })

    return response.data as OfferReservationResponse
  },

  /**
   * Vytvorenie novej rezerácie jedla na daný deň
   *
   * @param rootState
   * @param payload PlaceNewReservationPayload
   */
  async [actionTypes.PLACE_NEW_RESERVATION]({rootState}: { rootState: GlobalState }, payload: CreateNewReservationPayload): Promise<MenuReservationItem> {

    const response: AxiosResponse = await axios.post('/api/food-ordering/offer-reservation',payload, {
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem('token')
      }
    })

    return MenuReservationItem.createFromResponse(response.data)
  },

  /**
   * Zmena existujúcej rezerácie jedla
   *
   * @param payload ChangeExistingReservationPayload
   */

  async [actionTypes.CHANGE_EXISTING_RESERVATION]({}, payload: ChangeExistingReservationWithIdPayload): Promise<MenuReservationItem> {
    const response: AxiosResponse = await axios.put(`/api/food-ordering/offer-reservation/${payload.reservationId}`, payload.payload, {
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem('token')
      }
    })

    return MenuReservationItem.createFromResponse(response.data)
  },

  /**
   * Zrušenie existujúcej rezervácie
   *
   * @param payload MenuReservationItem
   */
  async [actionTypes.CANCEL_EXISTING_RESERVATION]({}, payload: MenuReservationItem): Promise<MenuReservationItem> {
    const response: AxiosResponse = await axios.put(`/api/food-ordering/offer-reservation/${payload.reservationId}`, {
      status: 'canceled'
    }, {
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem('token')
      }
    })

    return MenuReservationItem.createFromResponse(response.data)
  },

  /**
   * Obnovenie zrušenej rezervácie
   *
   * @param payload MenuReservationItem
   */
  async [actionTypes.RESTORE_EXISTING_RESERVATION]({}, payload: MenuReservationItem): Promise<MenuReservationItem> {
    const response: AxiosResponse = await axios.put(`/api/food-ordering/offer-reservation/${payload.reservationId}`, {
      status: 'active'
    }, {
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem('token')
      }
    })

    return MenuReservationItem.createFromResponse(response.data)
  },

  /**
   * Načítanie najnovších vyúčtovaní
   */
  async [actionTypes.FETCH_MY_LATEST_INVOICES]({}): Promise<Invoice|null> {
    const response: AxiosResponse = await axios.get(`/api/my/invoice/latest`, {
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem('token')
      }
    })

    let invoice: Invoice | null = null

    if (response.data[0]) {
      invoice = Invoice.createFromResponse(response.data[0])
    }

    return invoice
  },

  async [actionTypes.DOWNLOAD_INVOICE]({}, payload: Invoice): Promise<void> {
    const response = await axios.get(`/api/invoice/${payload.id}/download`, {
      responseType: 'blob',
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem('token')
      }
    })

    const blob = new Blob([response.data], { type: 'application/pdf' })
    const link = document.createElement('a')

    link.href = URL.createObjectURL(blob)
    link.download = response.headers['content-disposition'].split('=')[1]
    link.click()
    URL.revokeObjectURL(link.href)
  },

  async [actionTypes.FETCH_INVOICES]({}): Promise<Invoice[]> {
    const response: AxiosResponse = await axios.get(`/api/account/invoice`, {
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem('token')
      }
    })

    return Invoice.createListFromResponse(response.data)
  },

  async [actionTypes.FETCH_INVOICE_DETAIL]({}, payload: Invoice ): Promise<Invoice> {
    const response: AxiosResponse = await axios.get(`/api/invoice/${payload.id}`, {
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem('token')
      }
    })
    return Invoice.createFromResponse(response.data)
  }
}

const foodOrderingModule = {
  state,
  getters,
  mutations,
  actions
}

export default foodOrderingModule
